import { render, staticRenderFns } from "./DriveFileAdded.vue?vue&type=template&id=2d3d22ac&scoped=true"
import script from "./DriveFileAdded.vue?vue&type=script&lang=js"
export * from "./DriveFileAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d22ac",
  null
  
)

export default component.exports